export default (props, vars) => props?.['name'] === 'facebook';
